<main>
  <p-toast position="bottom-right" key="br"></p-toast>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <header>
    <div class="headline">
      <h1>
        {{ isEditing ? ('Greige_Title' | translateWF: 'Greige') + ' ' + greige?.greigeCode : ('Greige_Details_Title' | translateWF: 'Greige Details') }}
      </h1>
      <csl-dropdown [enumObject]="statusesEnum" [enumValueOptions]="greigeStatusOptions" [formControl]="status" />
    </div>
    <div class="buttons">
      <button pButton class="cs-button-link" label="Manual" (click)="goToInternalLink()">
        <i class="pi pi-arrow-right"></i>
      </button>
      <p-button *ngIf="canEdit()" [label]="'Common_Save' | translateWF: 'Save'" (click)="onSave()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
    </div>
  </header>

  <div class="content">
    <p-panel>
      <p-card>
        <div class="grid-12 gap-[2rem]">
          <div class="span-6">
            <div [formGroup]="basicInfo" id="basicInfo">
              <div class="form-box">
                <label for="fabricCategory">
                  {{ 'Fabric_Category' | translateWF: 'Fabric Category' }}
                </label>
                <p-autocomplete
                  fluid
                  #fabricCategorySearch="cslServerSearch"
                  [cslServerSearch]="fetchFabricCategories"
                  [suggestions]="fabricCategorySearch.results()"
                  field="acFieldToDisplay"
                  [dropdown]="true"
                  [forceSelection]="true"
                  formControlName="fabricCategory"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && fabricCategory.invalid,
                  }"
                >
                </p-autocomplete>
              </div>
            </div>
          </div>
          <div class="span-6">
            <app-card-composition [fabricComposition]="getFabricComposition()" [allCompositions]="allCompositions" />
          </div>
        </div>
      </p-card>
    </p-panel>
    <p-panel [formGroup]="basicInfo" [header]="'Greige_Other_Information' | translateWF: 'Other Information'">
      <p-card>
        <div class="col">
          <div class="form-box">
            <label for="wrapsPerInch">{{ 'Greige_Wraps_Per_Inch' | translateWF: 'Wraps per Inch' }}</label>
            <p-inputNumber
              formControlName="wrapsPerInch"
              [ngClass]="{
                'ng-invalid ng-dirty': formGroupSubmitted && basicInfo.get('wrapsPerInch')?.invalid,
              }"
            />
          </div>
          <!-- Courses per Inch -->
          <div class="form-box">
            <label for="coursesPerInch">{{ 'Greige_Courses_Per_Inch' | translateWF: 'Courses per Inch' }}</label>
            <p-inputNumber
              formControlName="coursesPerInch"
              [ngClass]="{
                'ng-invalid ng-dirty': formGroupSubmitted && basicInfo.get('coursesPerInch')?.invalid,
              }"
            />
          </div>
        </div>
      </p-card>
    </p-panel>
    <!-- Machine Information -->
    <p-panel [formGroup]="machineInfo" [header]="'Greige_Machine_Information' | translateWF: 'Machine Information'">
      <p-card>
        <div class="col">
          <div class="grid-12 gap-[1rem]">
            <div class="span-4">
              <div class="form-box">
                <label>{{ 'Greige_Machine_Type' | translateWF: 'Machine Type' }}</label>
                <p-autocomplete
                  fluid
                  #assetTypeSearch="cslServerSearch"
                  [cslServerSearch]="assetTypeTypeahead"
                  [suggestions]="assetTypeSearch.results()"
                  [dropdown]="true"
                  field="name"
                  formControlName="assetType"
                  class="w-full"
                  [forceSelection]="true"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && !assetType.value,
                  }"
                />
              </div>
            </div>
            <div class="span-4">
              <div class="form-box" *ngIf="machineInfo.get('assetType')?.value">
                <label>{{ 'Greige_Knitting_Machine' | translateWF: 'Machine' }}</label>
                <p-autocomplete
                  fluid
                  [dropdown]="true"
                  [forceSelection]="true"
                  #assetSearch="cslServerSearch"
                  [cslServerSearch]="fetchAssets"
                  [suggestions]="assetSearch.results()"
                  field="assetId"
                  formControlName="asset"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && !asset.value?.assetId,
                  }"
                />
              </div>
            </div>
            <div class="span-4">
              <div class="form-box">
                <label for="day">{{ 'Greige_Machine_Diameter' | translateWF: 'Diameter' }}</label>
                <p-inputNumber
                  formControlName="diameter"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && diameter.invalid,
                  }"
                />
              </div>
            </div>
          </div>
          <div class="grid-12 gap-[1rem]">
            <div class="span-4">
              <div class="form-box">
                <label for="gauge">{{ 'Greige_Machine_Gauge' | translateWF: 'Gauge' }}</label>
                <p-inputNumber
                  formControlName="gauge"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && gauge.invalid,
                  }"
                />
              </div>
            </div>
            <div class="span-4">
              <div class="form-box">
                <label for="rpm">{{ 'Greige_Machine_RPM' | translateWF: 'RPM' }}</label>
                <p-inputNumber
                  formControlName="rpm"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && rpm.invalid,
                  }"
                />
              </div>
            </div>
            <div class="span-4">
              <div class="form-box">
                <label for="feeders">{{ 'Greige_Machine_Feeders' | translateWF: 'Feeders' }}</label>
                <p-inputNumber
                  formControlName="feeders"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && feeders.invalid,
                  }"
                />
              </div>
            </div>
          </div>
          <div class="grid-12 gap-[1rem]">
            <div class="span-4">
              <div class="form-box">
                <label for="cylinderNeedles">{{ 'Greige_Machine_Cylinder_Needles' | translateWF: 'Cylinder Needles' }}</label>
                <p-inputNumber
                  formControlName="cylinderNeedles"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && cylinderNeedles.invalid,
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </p-card>
    </p-panel>

    <p-panel [header]="'Greige_Knitting_Process_Loss' | translateWF: 'Process Loss'">
      <p-card>
        <div class="grid-12 gap-[1rem]">
          <div class="span-3">
            <div class="form-box">
              <label for="">{{ 'Greige_Knitting_Process_Loss_User' | translateWF: 'Knitting Process Loss (User %)' }}</label>
              <p-inputGroup>
                <p-inputNumber
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && knittingProcessLossPercentage.invalid,
                  }"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [formControl]="knittingProcessLossPercentage"
                ></p-inputNumber>
                <p-inputgroup-addon>%</p-inputgroup-addon>
              </p-inputGroup>
            </div>
          </div>
          <div class="span-3">
            <div class="form-box">
              <label for="">{{ 'Greige_Knitting_Process_Loss_Internal' | translateWF: 'Internal Value (System %)' }}</label>
              <p-inputGroup>
                <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2" [formControl]="knittingProcessLossInternalPercentageControl"></p-inputNumber>
                <p-inputgroup-addon>%</p-inputgroup-addon>
              </p-inputGroup>
            </div>
          </div>
        </div>
      </p-card>
    </p-panel>

    <p-panel [header]="'Yarn_Info_Title' | translateWF: 'Yarns'">
      <ng-template pTemplate="icons">
        @if (canEdit()) {
          <p-button
            [label]="'Yarn_Info_Add_Additional' | translateWF: 'Add Additional Yarn'"
            icon="pi pi-plus"
            variant="outlined"
            (click)="yarnInfoCmp.addYarn()"
            [disabled]="!yarnInfoCmp.allowToAddNewYarn"
          />
        }
      </ng-template>
      <p-card>
        <div class="col">
          @if (yarnPercentageError) {
            <div class="grid-12">
              <div class="span-6">
                <p-message severity="error">{{
                  'Greige_Details_Yarn_Percentage_Error'
                    | translateWF
                      : 'Please check that the percentage for all yarn(s) add
                to 100'
                }}</p-message>
              </div>
            </div>
          }
          @if (checkDuplicateYarnLoopLength()) {
            <div class="grid-12">
              <div class="span-6">
                <p-message severity="error">{{
                  'Greige_Duplicate_Yarn_Loop_Length_Error'
                    | translateWF
                      : 'Two or more yarns with the same code cannot have
                the same loop length'
                }}</p-message>
              </div>
            </div>
          }
          <div class="grid-12">
            <div class="span-12">
              <app-yarn-info
                #yarnInfoCmp
                [yarnInfo]="yarnInfo"
                [needles]="needles"
                [readonly]="!canEdit() ? true : false"
                [canEdit]="canEdit()"
                [parentFormSubmitted]="formGroupSubmitted"
                [showTitle]="false"
              />
            </div>
          </div>
        </div>
      </p-card>
    </p-panel>

    <p-panel [formGroup]="capacityInfo" [header]="'Greige_Capacity_Information' | translateWF: 'Capacity Information'">
      <div class="grid-12 gap-[1rem]">
        <div class="span-6">
          <p-card>
            <div class="col">
              <div class="form-box-row">
                <label for="shiftA">{{ 'Greige_Shift' | translateWF: 'Shift' }} A</label>
                <input type="text" [value]="addCommasAndDecimal(capacityInfo.get('shiftA')?.value)" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="shiftB">{{ 'Greige_Shift' | translateWF: 'Shift' }} B</label>
                <input type="text" [value]="addCommasAndDecimal(capacityInfo.get('shiftB')?.value)" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="shiftC">{{ 'Greige_Shift' | translateWF: 'Shift' }} C</label>
                <input type="text" [value]="addCommasAndDecimal(capacityInfo.get('shiftC')?.value)" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="totalRevolutionsPerDay">{{ 'Greige_Shift_Revolutions' | translateWF: 'Total/Day' }}</label>
                <input type="text" [value]="addCommasAndDecimal(capacityInfo.get('totalRevolutionsPerDay')?.value)" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="totalKgPerDay">{{ 'Greige_Total_Kg_Per_Day' | translateWF: 'KGs/DAY' }}</label>
                <input type="number" [value]="totalKgPerDayValue" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="totalKgPerDayEfficiency">{{ 'Greige_Total_Kg_Efficiency' | translateWF: 'KGs/Day (Efficiency)' }}</label>
                <input type="text" [value]="addCommasAndDecimal(totalKgPerDayEfficiencyValue)" pInputText disabled class="cs-fill-width" />
              </div>
              <div class="form-box-row">
                <label for="obtainedEfficiency">{{ 'Greige_Efficiency' | translateWF: 'Obtained Efficiency' }}</label>
                <p-inputNumber
                  class="cs-fill-width"
                  formControlName="obtainedEfficiency"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && obtainedEfficiency.invalid,
                  }"
                />
              </div>
              <div class="form-box-row">
                <label for="numberOfMachines">{{ 'Greige_Number_Of_Machines' | translateWF: 'Number of Machines' }}</label>
                <p-inputNumber
                  class="cs-fill-width"
                  formControlName="numberOfMachines"
                  [ngClass]="{
                    'ng-invalid ng-dirty': formGroupSubmitted && numberOfMachines.invalid,
                  }"
                />
              </div>
            </div>
          </p-card>
        </div>
        <div class="span-6">
          @if (currentFileUploaded) {
            <p-panel data-tone="surface" [header]="'Greige_Knitting_Graph' | translateWF: 'Knitting Machine Graph'">
              <p-card>
                <ul class="files-list w-full col">
                  <li class="w-full border rounded-lg p-5 row-between-center cursor-pointer transition-all hover:scale-95" (click)="downloadFile()">
                    <p class="font-bold p-2 rounded-lg text-black bg-slate-300">
                      {{ extensionFile }}
                    </p>
                    <a class="truncate"> {{ nameFile }} </a>
                    <p-button *ngIf="canEdit()" icon="pi pi-trash" (click)="removeGraph(); $event.stopPropagation()" />
                  </li>
                </ul>
              </p-card>
            </p-panel>
          } @else {
            @if (canEdit()) {
              <div class="knitting-machine-graph">
                <h4 class="line">
                  {{ 'Greige_Knitting_Graph' | translateWF: 'Knitting Machine Graph' }}
                </h4>
                <p *ngIf="!isEditing">
                  {{ 'Greige_SaveBefore_Msg' | translateWF: 'Save greige to upload files' }}
                </p>
                <div *ngIf="isEditing" class="upload-dropzone" (click)="knittingMachineGraphFile.click()">
                  <input type="file" accept="*/*" (change)="onGraphUpload($event)" id="knittingMachineGraphFile" hidden #knittingMachineGraphFile />
                  <label for="knittingMachineGraphFile" class="upload-prompt">
                    <p>
                      {{ 'Common_Upload_Document' | translateWF: 'Upload Document' }}
                    </p>
                  </label>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </p-panel>
  </div>
</main>
